var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin74(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 21.8281 20.8594 33.9844 16.8516 39C15.8906 40.1953 14.1094 40.1953 13.1484 39C9.14062 33.9844 0 21.8281 0 15C0 6.71875 6.71875 0 15 0C23.2812 0 30 6.71875 30 15Z",
    fill: "#CF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3203 8.625V9.83594L9.92188 20H7.54688L11.9453 10.3828H6.28125V8.625H14.3203ZM23.75 15.75V17.5156H15.5547L15.4453 16.1484L20.1875 8.625H21.9766L20.0391 11.8672L17.6797 15.75H23.75ZM22.4609 8.625V20H20.2109V8.625H22.4609Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin74);
export default __webpack_public_path__ + "static/media/Pin74.a94c33f28184c136eb04dd64980fd303.svg";
export { ForwardRef as ReactComponent };